
export default {
  name: 'SectionProducts',

  props: {
    section: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    updateForCart: async function (productId) {
      const products = this.section?.products || [];
      const currentAddCount = (this.$store.state.cart?.items || []).find((t) => t?.product?.id === productId)?.quantity || 0;
      this.$yandexMetrika.reachGoal('add_to_cart_collection');
      if (currentAddCount <= 0) {
        await this.addToCart(productId);
        return;
      }
      const count = currentAddCount + 1;
      const success = await this.$store.dispatch('cart/updateCartItem', {
        cartItemId: (this.$store.state.cart?.items || []).find((t) => t?.product?.id === productId)?.id,
        quantity: count,
      });
      if (!success) {
        this.$toast.error('Невозможно изменить количество товара в корзине');
        return;
      }

      this.$toast.success('Количество товара изменено');
      const product = products.find((t) => t.id === productId);
      this.$yandexCommerce('add', [{
        ...product,
        quantity: 1,
      }]);

      await this.$store.dispatch('cart/getCart');
    },
    addToCart: async function (productId) {
      const products = this.section?.products || [];
      const productItemCart = {
        productId: productId,
        quantity: 1,
      };
      const res = await this.$store.dispatch('cart-custom/putToCart', productItemCart);
      if (!res.isSuccess) {
        this.$toast.error(res.errorMessage);
        return;
      }
      this.$toast.success('Товар добавлен в корзину');
      const product = products.find((t) => t.id === productId);
      this.$yandexCommerce('add', [{
        ...product,
        quantity: 1,
      }]);
      await this.$store.dispatch('cart/getCart');
    },
    orderOneClick: function (product) {
      this.$store.commit('fast-buy/open', product);
    },

    _getProductName: function (product) {
      if (product?.shortDescription) {
        return product.shortDescription;
      }

      const characteristicGroupId = product?.characteristicGroupId;

      const characteristics = [];
      (product?.characteristics || []).map((t) => {
        characteristics.push(...(t.characteristics || []));
      });

      if (characteristicGroupId === 3) {
        return characteristics.find((t) => t.slug === 'disksize')?.values?.[0]?.value || product.name;
      }
      if (characteristicGroupId === 2) {
        return characteristics.find((t) => t.slug === 'tiporazmer')?.values?.[0]?.value || product.name;
      }
    },
    _getProductImage: function (product) {
      const imageId = (product?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'season')?.values?.[0]?.imageId;
      if (!imageId) {
        return '';
      }
      return this.$img(String(imageId), {
        width: 32,
        height: 32,
        fit: 'fill',
      });
    },
    _getProductQuantity: function (productId) {
      return (this.$store.state.cart?.items || []).find((t) => t?.product?.id === productId)?.quantity || 0;
    },

    _getProductSku: function (product) {
      const { characteristicGroupId } = product;

      if ([12, 13].includes(characteristicGroupId)) {
        return product.sku;
      }

      return product.code;
    },
  },
};
